const POST_COMPONENT_TYPE = {
  title: 'title',
  bannerWithTextBox: 'bannerWithTextBox',
  bannerWithList: 'bannerWithList',
  bannerWithTextAndDescription: 'bannerWithTextAndDescription',
  bannerWithListAndProductCard: 'bannerWithListAndProductCard'
};

export default POST_COMPONENT_TYPE;
